/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CancelSubscriptionDto
 */
export interface CancelSubscriptionDto {
    /**
     * 
     * @type {Date}
     * @memberof CancelSubscriptionDto
     */
    subscriptionEndDate: Date | null;
}

export function CancelSubscriptionDtoFromJSON(json: any): CancelSubscriptionDto {
    return CancelSubscriptionDtoFromJSONTyped(json, false);
}

export function CancelSubscriptionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CancelSubscriptionDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'subscriptionEndDate': (json['subscriptionEndDate'] === null ? null : new Date(json['subscriptionEndDate'])),
    };
}

export function CancelSubscriptionDtoToJSON(value?: CancelSubscriptionDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'subscriptionEndDate': (value.subscriptionEndDate === null ? null : value.subscriptionEndDate.toISOString()),
    };
}

